import keysCollection from '../../utilities/keysCollection'

export const Keys = keysCollection('ASIGN_PERSMISION', {
    GROUP: 'GROUP',
    CHECKS: 'CHECKS'
})
